import { Navigate } from "react-router-dom";
import usePermissions from "datasets/hooks/usePermissions";
import { ROUTE_404 } from "~/router/constants";
import { AddTable } from "./tables/AddTable";

export const DatasetAddTable = () => {
  const canCreate = usePermissions("create:catalog-ingest");
  if (!canCreate) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <AddTable />;
};
